/* eslint-disable import/prefer-default-export */

// Create lead
export const CREATE_LEAD_FAILURE = 'CREATE_LEAD_FAILURE'
export const CREATE_LEAD_REQUEST = 'CREATE_LEAD_REQUEST'
export const CREATE_LEAD_SUCCESS = 'CREATE_LEAD_SUCCESS'
export const CREATE_LEAD_ERROR = 'CREATE_LEAD_ERROR'

export const SAVE_LEAD_SECRET_TOKEN = 'SAVE_LEAD_SECRET_TOKEN'

// Fetch single position
export const FETCH_POSITION_FAILURE = 'FETCH_POSITION_FAILURE'
export const FETCH_POSITION_REQUEST = 'FETCH_POSITION_REQUEST'
export const FETCH_POSITION_SUCCESS = 'FETCH_POSITION_SUCCESS'

// Fetch multiple positions
export const FETCH_POSITIONS_FAILURE = 'FETCH_POSITIONS_FAILURE'
export const FETCH_POSITIONS_REQUEST = 'FETCH_POSITIONS_REQUEST'
export const FETCH_POSITIONS_SUCCESS = 'FETCH_POSITIONS_SUCCESS'

// State API
export const RECEIVE_STATE_INFO = 'RECEIVE_STATE_INFO'
export const REQUEST_STATE_INFO = 'REQUEST_STATE_INFO'

// Geocoding
export const GEOCODE_FAILURE = 'GEOCODE_FAILURE'
export const GEOCODE_LATLNG_SUCCESS = 'GEOCODE_LATLNG_SUCCESS'
export const GEOCODE_REQUEST = 'GEOCODE_REQUEST'
export const GEOCODE_SUCCESS = 'GEOCODE_SUCCESS'

// Select position
export const SELECT_POSITION = 'SELECT_POSITION'

// Submit 'wants to run' form
export const SUBMIT_RUN_FORM = 'SUBMIT_RUN_FORM'

// UTM parameters
export const SAVE_UTM_PARAMS = 'SAVE_UTM_PARAMS'


// WEBPACK FOOTER //
// ./src/constants/officeRunnerConstants.js